import type { CompanyUser } from "../../api/companyUsers.service";

export const COLUMN_CONFIGS = [
  {
    header: "User ID",
    accessor: "userId" as keyof CompanyUser,
  },
  {
    header: "Name",
    accessor: "userName" as keyof CompanyUser,
  },
  {
    header: "Email",
    accessor: "userEmail" as keyof CompanyUser,
  },
  {
    header: "Company",
    accessor: "companyName" as keyof CompanyUser,
  },
  {
    header: "Company ID",
    accessor: "companyId" as keyof CompanyUser,
  },
  {
    header: "Firm Ref",
    accessor: "companyFirmRef" as keyof CompanyUser,
  },
];

export const MODAL_FIELD_CONFIGS: Array<{ key: keyof CompanyUser; label: string }> = [
  { key: "userId", label: "User ID" },
  { key: "userName", label: "Name" },
  { key: "userEmail", label: "Email" },
  { key: "companyId", label: "Company ID" },
  { key: "companyName", label: "Company Name" },
  { key: "companyFirmRef", label: "Firm Reference" },
  {
    key: "metadata",
    label: "Metadata",
  },
];
